import React from 'react';
import { Expired as ExpiredComponent } from '~/components/Auth';

export function Expired() {
    return (
        <div className="container">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-6">
                        <ExpiredComponent />
                    </div>
                </div>
            </div>
        </div>
    );
}
